import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { Observable, of } from 'rxjs';
import { Evenement } from '../../models/evenement.class';
import { AsyncPipe } from '@angular/common';
import { ThemesWrapperComponent } from "../../components/themes-wrapper/themes-wrapper.component";
import { NgStyle } from '@angular/common';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-evenement',
  imports: [AsyncPipe, ThemesWrapperComponent, NgStyle],
  templateUrl: './evenement.component.html',
  styleUrl: './evenement.component.scss'
})
export class EvenementComponent {
  route: ActivatedRoute = inject(ActivatedRoute);
  apiService: ApiService = inject(ApiService);
  evenement$: Observable<Evenement | null> = of(null);
  apiUrl = environment.API_URL;
  
  ngOnInit(): void {
    const evenementId: string = this.route.snapshot.params['id'];
    console.log("Evenement ID:", evenementId);
    this.evenement$ = this.apiService.getEvenement(evenementId);
  }
}
